import React from "react";
import cx from "classnames";

import s from "./ResetFiltersButton.module.scss";

export default function ResetFiltersButton({
	className = "",
	resetFilters = () => {},
}) {
	return (
		<div className={cx(s.root, className)} onClick={resetFilters}>
			Reset Filters x
		</div>
	);
}
